"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_TEMPLATE_MIMES = exports.PPTX_MIME = exports.SVG_MIME = exports.BRAND_TEMPLATE_MAX_LABEL = exports.BRAND_TEMPLATE_MAX_BYTES = exports.TEMPLATE_ROLES = exports.BrandTemplateKind = void 0;
/**
 * A reusable design template a workspace uploaded, which Generate Design fills with new content.
 *
 * Two kinds, and they are not symmetric. A Figma template is an `.svg` — text, ids and geometry are
 * readable as plain markup, and the browser renders it, so it needs no thumbnail pipeline at all. A
 * Canva template is a `.pptx` — a zip whose shape names sit in compressed XML, so reading it goes to
 * the parse service, and nothing in this system can rasterise it for a preview.
 */
var BrandTemplateKind;
(function (BrandTemplateKind) {
    BrandTemplateKind["FIGMA_SVG"] = "FIGMA_SVG";
    BrandTemplateKind["CANVA_PPTX"] = "CANVA_PPTX";
})(BrandTemplateKind || (exports.BrandTemplateKind = BrandTemplateKind = {}));
exports.TEMPLATE_ROLES = [
    { role: 'headline', label: 'Headline', required: true },
    { role: 'subhead', label: 'Subhead', required: false },
    { role: 'image', label: 'Image', required: false },
    { role: 'logo', label: 'Logo', required: false },
];
/** The one size limit for a template upload. */
exports.BRAND_TEMPLATE_MAX_BYTES = 10 * 1024 * 1024;
exports.BRAND_TEMPLATE_MAX_LABEL = '10MB';
exports.SVG_MIME = 'image/svg+xml';
exports.PPTX_MIME = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
/** Which mime each kind accepts. An exact match, never a prefix — this is an upload boundary. */
exports.BRAND_TEMPLATE_MIMES = {
    [BrandTemplateKind.FIGMA_SVG]: exports.SVG_MIME,
    [BrandTemplateKind.CANVA_PPTX]: exports.PPTX_MIME,
};
//# sourceMappingURL=brand-template.js.map